export default __webpack_public_path__ + "static/media/proxy-hint.a375cd7b.svg";